import { useEffect, useState } from 'react'

import { initialPagination, type PaginationParams } from '@components/shared/Table/components/Pagination/types'
import { PageWrapper } from '@components/shared/PageWrapper'
import { parseUsersGrid } from './helpers/parseUsersGrid'
import { RowTableTotal2 } from '@components/shared/RowTableTotal2'
import { Table } from '@components/shared/Table'
import { UserDataModal } from '@pages/Users/components/UserDataModal'
import { UsersFilters } from './components/UsersFilters'
import { useUsers } from './context'

import type { SortProps } from '@components/shared/Table/types'
import type { UserItemProps } from './context/types'

export const Users = () => {
  const { usersData, isUsersLoading, getUsers } = useUsers()

  const [openUserDataModal, setOpenUserDataModal] = useState(false)
  const [userData, setUserData] = useState<UserItemProps | null>(null)
  const [usersSortData, setUsersSortData] = useState<SortProps | null>(null)
  const [usersFormData, setUsersFormData] = useState<UserItemProps | null>(null)

  const handleUserDetails = (data: UserItemProps) => {
    setOpenUserDataModal(true)
    setUserData(data)
  }

  const handleGetUsers = (params: PaginationParams | null, formData?: UserItemProps | null, sortData?: SortProps) => {
    getUsers({
      ...(sortData || usersSortData),
      ...(formData || usersFormData)!,
      page: params?.page || initialPagination.PAGE,
      itemsPerPage: params?.itemsPerPage || usersData?.itemsPerPage || initialPagination.ITEMS_PER_PAGE
    })
    !!formData && setUsersFormData(formData)
    !!sortData && setUsersSortData(sortData)
  }

  const handleInitialActionsFromScreen = () => {
    handleGetUsers(null)
  }

  useEffect(() => {
    handleInitialActionsFromScreen()
  }, [])

  return (
    <>
      <PageWrapper breadcrumbData={[{ label: 'Usuários' }]}>
        <UsersFilters onFilter={(formData) => handleGetUsers(null, formData)} />

        <Table
          data={parseUsersGrid({
            data: usersData?.items || [],
            onSeeMore: handleUserDetails
          })}
          fixedRow={{
            element: <RowTableTotal2 data={[{ label: 'Total Registros', value: usersData?.totalItems || 0 }]} />
          }}
          footer={{
            pagination: {
              currentPage: usersData?.currentPage,
              itemsPerPage: usersData?.itemsPerPage,
              totalItems: usersData?.totalItems,
              totalPages: usersData?.totalPages,
              onPageChange: (page) => handleGetUsers({ page }),
              onItemsPerPageChange: (itemsPerPage) => handleGetUsers({ itemsPerPage })
            }
          }}
          onSort={(sortData) => handleGetUsers(null, null, sortData)}
          isLoading={isUsersLoading}
        />
      </PageWrapper>

      <UserDataModal data={userData} open={openUserDataModal} onClose={setOpenUserDataModal} />
    </>
  )
}
